import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import {
  ScholarshipManagementDto,
  StateDto,
  LgaDto,
  ScholarshipTypeDto,
  ScholarshipCategoryDto,
  ScholarshipSessionDto,
  ScholarshipAwardDurationDto,
  CommunityDto,
  CourseOfStudyDto,
  EpimsGenderDto,
  CountryDto,
  BankDto,
  ScholarshipPaymentDto,
} from '@cradua/data';
import { ScholarshipInfoService } from '../../services/scholarshipinfo.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from 'libs/shared/src/lib/components/modal/modal.component';

@Component({
  selector: 'mrsoftapps-scholarship-payment-report',
  templateUrl: './scholarship-payment-report.component.html',
  styleUrls: ['./scholarship-payment-report.component.scss'],
})
export class ScholarshipPaymentReportComponent implements OnInit {
  @Input() countries: CountryDto[];
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() scholarshipTypes: ScholarshipTypeDto[];
  @Input() scholarshipCategories: ScholarshipCategoryDto[];
  @Input() scholarshipData: ScholarshipManagementDto;
  @Input() courseOfStudies: CourseOfStudyDto[];
  @Input() scholarshipSessions: ScholarshipSessionDto[];
  @Input() scholarshipAwardDurations: ScholarshipAwardDurationDto[];
  @Input() genders: EpimsGenderDto[];
  @Input() communities: CommunityDto[];
  @Input() scholarshipManagements: ScholarshipManagementDto[];
  @Input() scholarshipPayments: ScholarshipPaymentDto[];
  @Input() banks: BankDto[];

  constructor(
    private scholarshipInfService: ScholarshipInfoService,
    public matDialog: MatDialog
  ) {}

  ngOnInit() {}

  // openCreatePaymentModal() {
  // 	const dialogConfig = new MatDialogConfig();
  // 	// The user can't close the dialog by clicking outside its body
  // 	dialogConfig.disableClose = true;
  // 	dialogConfig.id = 'modal-component';
  // 	dialogConfig.height = '600px';
  // 	dialogConfig.width = '50%';
  // 	dialogConfig.data = {
  // 		name: 'report',
  //     student: this.scholarshipData,
  //     scholarshipPayment: this.scholarshipPayments,
  // 		banks: this.banks
  // 	};

  // 	const modalDialog = this.matDialog.open(ModalComponent, dialogConfig);
  // 	modalDialog.afterClosed().subscribe((result) => {
  // 		console.log(`Dialog result: ${result}`);
  // 		if (result !== undefined) {
  // 			// this.paymentEmit.emit(result);
  // 		}
  // 	});

  // }
}
